import {NgModule} from '@angular/core';
import {EducationPageComponent} from './education-page.component';
import {PageCommonModule} from '../shared/page-common.module';
import {FormsModule} from '../../components/forms/forms.module';
import {NgbDatepickerModule} from '@ng-bootstrap/ng-bootstrap';
import {StepScreenModule} from '../shared/step/step-screen.module';
import {EcfmgScreenComponent} from './steps/premedical/ecfmg/ecfmg-screen.component';
import {PremedicalEducationScreenComponent} from './steps/premedical/premedical/premedical-screen.component';
import {MedicalEducationScreenComponent} from './steps/medical/medical-education-screen.component';
import {OtherEducationScreenComponent} from './steps/other/other-education-screen.component';
import {InternshipScreenComponent} from './steps/internship/internship-screen.component';
import {ResidencyScreenComponent} from './steps/residency/residency-screen.component';
import {FellowshipOrPreceptorshipScreenComponent} from './steps/fellowshipOrPreceptorship/fellowship-or-preceptorship-screen.component';
import {CompletedMedicalSchoolInUsaScreenComponent} from './steps/premedical/question/completed-medical-school-in-usa-screen.component';

/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
@NgModule({
    imports: [
        PageCommonModule,
        FormsModule,
        StepScreenModule,
        NgbDatepickerModule
    ],
    declarations: [
        EducationPageComponent,
        CompletedMedicalSchoolInUsaScreenComponent,
        EcfmgScreenComponent,
        PremedicalEducationScreenComponent,
        MedicalEducationScreenComponent,
        OtherEducationScreenComponent,
        InternshipScreenComponent,
        ResidencyScreenComponent,
        FellowshipOrPreceptorshipScreenComponent
    ]
})
export class EducationPageModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/education/education-page.module.ts